

export class BranchDetailStatusInput implements IBranchDetailStatusInput {
    /** The auto-generated id of the tbl_branch_detail */
    branchDetailId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IBranchDetailStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BranchDetailStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IBranchDetailStatusInput {
    /** The auto-generated id of the tbl_branch_detail */
    branchDetailId: number;
    /** The updated status */
    status: number;
}

